import React, { useState, useEffect } from 'react';
import Menu from '../../Components/UserComponents/Menu';
import { Link } from 'react-router-dom';
import Chart from '../../Components/UserComponents/Chart';
import styled from 'styled-components';
import EditIcon from '@mui/icons-material/Edit';
import PhotosTable from '../../Components/UserComponents/PhotosTable';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useParams } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';

function Single({ title, isMobile }) {
  const [data, setData] = useState([]);
  const { userId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'users', userId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [userId]);

  return (
    <SingleStyled>
      <Menu title={title} isMobile={isMobile} />
      <div className="single-container">
        <div className="datatable">
          <div className="top" key={data.id}>
            <div className="left">
              <div className="edit-button">
                <Link to={`/${userId}/update`} className="link">
                  <Tooltip title="Edit Profile">
                    <Fab color="primary" aria-label="add" sx={{ backgroundColor: '#7199ff' }}>
                      <EditIcon sx={{ color: 'fff' }} />
                    </Fab>
                  </Tooltip>
                </Link>
              </div>
              <h1 className="title">Information</h1>

              <div className="item">
                <img src={data.img} alt="" className="item-img" />

                <div className="details">
                  <h1 className="item-title">{data.username}</h1>
                  <div className="detail-item">
                    <span className="item-key">Email:</span>
                    <span className="item-value">{data.email}</span>
                  </div>
                  <div className="detail-item">
                    <span className="item-key">Phone:</span>
                    <span className="item-value">{data.phone}</span>
                  </div>
                  <div className="detail-item">
                    <span className="item-key">Address:</span>
                    <span className="item-value">{data.address}</span>
                  </div>
                  <div className="detail-item">
                    <span className="item-key">Country:</span>
                    <span className="item-value">{data.country}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="right">
              <Chart aspect={3 / 1} title="User photos added (Last month)" />
            </div>
          </div>
          <div className="bottom">
            <PhotosTable isMobile={isMobile} />
          </div>
        </div>
      </div>
    </SingleStyled>
  );
}

const SingleStyled = styled.div`
  display: flex;
  width: 100%;
  padding-top: 4rem;
  min-height: 100vh;
  .single-container {
    flex: 6;
    .datatable {
      padding: 20px;

      .datatable-title {
        width: 100%;
        font-size: 14px;
        color: var(--accent-blue);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .top {
        padding: 20px 0;
        display: flex;
        gap: 20px;
        @media screen and (max-width: 956px) {
          display: grid;
        }
        .left {
          flex: 1;
          -webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.4);
          box-shadow: 2px 4px 10px 1px rgba(201, 201, 201, 0.4);
          padding: 10px;
          position: relative;

          .edit-button {
            position: absolute;
            top: -4%;
            right: -2%;
            padding-top: -1rem;
            font-size: 12px;

            cursor: pointer;
            border-radius: 0px 0 0px 5px;
          }

          .item {
            display: flex;
            gap: 20px;
            padding: 20px;
            @media screen and (max-width: 956px) {
              padding-top: 2rem;
              display: block;
              justify-content: center;
              align-items: center;
              text-align: center;
            }

            .item-img {
              width: 100px;
              height: 100px;
              border-radius: 50%;
              object-fit: cover;
            }

            .details {
              .item-title {
                margin-bottom: 10px;
                color: #555;
              }

              .detail-item {
                margin-bottom: 10px;
                font-size: 14px;

                .item-key {
                  font-weight: bold;
                  color: gray;
                  margin-right: 5px;
                }
              }
            }
          }
        }
      }

      .right {
        flex: 2;
      }
    }
    .bottom {
      .list-title {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 0px;
        color: var(--accent-blue);
      }
    }

    .title {
      color: var(--accent-blue);
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 20px;
      padding: 10px;
    }
  }
  .viewButton {
    padding: 2px 5px;
    border-radius: 5px;
    color: darkblue;
    border: 1px dotted rgba(0, 0, 139, 0.6);
    cursor: pointer;
  }
`;

export default Single;
